// Live "Can be refunded: ₹X" fetch for the picker display (SPEC §5.1, §4.3).
//
// One GET per salesOrderId change; the result stays stable until the picker is unmounted or the
// salesOrderId changes. Headroom shrinks AFTER the parent submits a successful raise/Authorize,
// but the parent closes the modal on success so an in-component refetch is not needed.

import axios from "axios";
import { useEffect, useState } from "react";

interface HeadroomState {
  canBeRefundedPaise: number | null;
  loading: boolean;
  error: string | null;
}

export function useHeadroom(salesOrderId: number): HeadroomState {
  const [state, setState] = useState<HeadroomState>({
    canBeRefundedPaise: null,
    loading: true,
    error: null,
  });

  useEffect(() => {
    let cancelled = false;
    setState({ canBeRefundedPaise: null, loading: true, error: null });
    axios
      .get(`/oms/sales-orders/${salesOrderId}/refund-headroom/`)
      .then((resp) => {
        if (cancelled) return;
        const paise = resp?.data?.headroom_remaining_paise;
        setState({
          canBeRefundedPaise: typeof paise === "number" ? paise : null,
          loading: false,
          error: null,
        });
      })
      .catch((err: any) => {
        if (cancelled) return;
        setState({
          canBeRefundedPaise: null,
          loading: false,
          error:
            err?.response?.data?.detail ||
            err?.message ||
            "Unable to load headroom",
        });
      });
    return () => {
      cancelled = true;
    };
  }, [salesOrderId]);

  return state;
}
